import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", { class: "flex place-content-center text-lg font-bold font-sans m-2" }, "Foto-Patricia", -1)
const _hoisted_2 = { class: "mx-8 md:mx-4 lg:flex lg:place-content-center" }
const _hoisted_3 = { class: "grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 justify-evenly" }

import SimpleIconButton from "./components/SimpleIconButton.vue";
import FeatherButton from "./components/FeatherButton.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(FeatherButton, {
          name: "Kontakt",
          link: "/vcard.vcf",
          icon: "user-plus",
          "color-name": "contact"
        }),
        _createVNode(FeatherButton, {
          name: "Homepage",
          link: "https://www.foto-patricia.ch",
          icon: "home",
          "color-name": "website"
        }),
        _createVNode(SimpleIconButton, {
          name: "Facebook",
          link: "https://www.facebook.com/FotoPatriciaPolakova",
          icon: "FacebookIcon",
          "color-name": "facebook"
        }),
        _createVNode(SimpleIconButton, {
          name: "Instagram",
          link: "https://www.instagram.com/fotopatriciapolakova/",
          icon: "InstagramIcon",
          "color-name": "instagram"
        }),
        _createVNode(SimpleIconButton, {
          name: "WhatsApp",
          link: "https://api.whatsapp.com/send?phone=41763471818",
          icon: "WhatsappIcon",
          "color-name": "whatsapp"
        })
      ])
    ])
  ], 64))
}
}

})